<template>
  <div>

    <el-row :gutter="5">
      <el-form>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="reset">清空搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="onShowSave('新增')">新增</el-button>
        </el-col>
      </el-form>
    </el-row>

    <el-table v-loading="loadTable" :data="records" stripe height="450">
      <el-table-column fixed label="ID" prop="id">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.id }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="展示名字" prop="name">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.name }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="图标" prop="icon">
        <template slot-scope="scope">
          <div class="demo-image__preview">
            <el-image
                style="width: 50px; height: 50px"
                :src="fileBaseUrl+scope.row.icon"
                :preview-src-list="[fileBaseUrl+scope.row.icon]">
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="地址" prop="address">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.address }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="关联类型" prop="linkType">
        <template slot-scope="scope">
          <span v-if="scope.row.linkType==='0'">企业</span>
          <span v-if="scope.row.linkType==='2'">企业类型</span>
          <span v-if="scope.row.linkType==='1'">小程序</span>
          <span v-if="scope.row.linkType==='3'">店铺</span>
          <span v-if="scope.row.linkType==='4'">商品</span>
        </template>
      </el-table-column>
      <el-table-column label="关联值" prop="linkValue">
        <template slot-scope="scope">
              <span>
                 {{ scope.row.linkValue }}
              </span>
        </template>
      </el-table-column>
      <el-table-column label="是否隐藏" prop="isHide">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.isHide }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createdTime">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.createdTime }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="onShowSave('修改', scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>










    <!--  保存  -->
    <el-dialog
        :title="title"
        :visible.sync="showSave"
        width="30%"
        center>

      <el-form label-position="left" label-width="130px" :model="save" ref="ruleForm">
        <el-form-item label="地图展示名字" prop="name"
                      :rules="[
                        {required: true, message: '请输入地图展示名字', trigger: 'blur'},
                        {max: 20, message: '长度最高为20', trigger: 'blur'}
                        ]">
          <el-input v-model="save.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon"
                      :rules="[
                        {required: true, message: '请上传图标', trigger: 'blur'},
                        ]">
          <div class="avatar-uploader">
            <el-upload
                :action="fileBaseUrl"
                :show-file-list="false"
                :data="uploadData"
                accept="image/*"
                :before-upload="beforeUpload"
                :on-success="handleSuccess"
            >
              <img v-if="save.icon" :src="save.icon" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>
        </el-form-item>
        <el-form-item label="图标宽" prop="width"
                      :rules="[
                        { required: true, message: '不能为空'},
                        { type: 'number', message: '必须为数字值'},
                        { validator: notLtNum1, trigger: 'blur' },
                        { validator: notGtNum100, trigger: 'blur' },
                        ]">
          <el-input v-model.number="save.width" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图标高" prop="height"
                      :rules="[
                        { required: true, message: '不能为空'},
                        { type: 'number', message: '必须为数字值'},
                        { validator: notLtNum1, trigger: 'blur' },
                        { validator: notGtNum100, trigger: 'blur' },
                        ]">
          <el-input v-model.number="save.height" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address"
                      :rules="[
                        {required: true, message: '请输入地址', trigger: 'blur'},
                        ]">
          <template>
            <div style="cursor: pointer;width: 20px;display: inline-block" @click="onShowMap">
              <i
                  class="el-icon-location hostlocation"
              ></i>
            </div>
            <div style="display: inline-block"><el-input v-model="save.address" disabled></el-input></div>
          </template>
        </el-form-item>
        <el-form-item label="关联类型" prop="linkType"
                      :rules="[
                        {required: true, message: '请输入关联类型', trigger: 'blur'},
                        ]">
          <el-select v-model="save.linkType" clearable placeholder="关联类型">
            <el-option
                v-for="item in linkTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联值" prop="linkValue"
                      :rules="[
                        {required: true, message: '请输入关联值', trigger: 'blur'},
                        ]">
          <el-input
              v-model="save.linkValue"
              clearable
              :placeholder="
              save.linkType==='0'?
              '请输入企业ID':save.linkType==='1'?
              '请输入小程序APPID':save.linkType==='2'?
              '请输入企业类型ID':save.linkType==='3'?
              '请输入店铺ID':'请输入商品ID'
          "></el-input>
        </el-form-item>
        <el-form-item label="是否隐藏" prop="isHide"
                      :rules="[
                        {required: true, message: '请选择是否隐藏', trigger: 'blur'},
                        ]">
          <el-select v-model="save.isHide" clearable placeholder="请选择是否隐藏">
            <el-option
                v-for="item in isHides"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showSave = false">取 消</el-button>
        <el-button type="primary" @click="doSave('ruleForm')">提 交</el-button>
      </span>
    </el-dialog>

    <!--    插入定位 -->
    <el-dialog
        title="插入定位(只支持腾讯地图坐标)"
        :visible.sync="showAddCoord"
        width="30%"
        center>

      <el-form label-position="left" label-width="80px" :model="coord" ref="coordForm">
        <el-form-item label="坐标" prop="lnglat"
                      :rules="[
                        {required: true, message: '请输入坐标', trigger: 'blur'},
                        {max: 255, message: '长度最高为255', trigger: 'blur'}
                        ]">
          <el-input
              clearable
              placeholder="请输入坐标"
              v-model="coord.lnglat">
          </el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address"
                      :rules="[
                        {required: true, message: '请输入地址', trigger: 'blur'},
                        {max: 255, message: '长度最高为255', trigger: 'blur'}
                        ]">
          <el-input
              clearable
              placeholder="请输入地址"
              v-model="coord.address">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddCoord = false">取 消</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click.native="insertLocation('coordForm')">插入地点</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import {Message} from "element-ui";
import save from "@/api/MapMarker/save";
import list from "@/api/MapMarker/list";
import {notGtNum100, notLtNum0, notLtNum1} from "@/utils/check";
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";

export default {
  name: "MapMarkerManage",
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      uploadData:{},
      params: {},
      loadTable: false,
      records: [],

      title:'',
      save:{
        isHide:'否',
        icon:undefined,
        width:50,
        height:50,
      },
      showSave:false,

      showAddCoord:false,
      coord:{
        lnglat:'',
        address:'',
      },

      isHides:[
        {
          value:'是',
          label:'是',
        },
        {
          value:'否',
          label:'否',
        },
      ],


      linkTypes:[
        {
          value: '0',
          label: '企业',
        },
        {
          value: '1',
          label: '小程序',
        },
        {
          value: '3',
          label: '店铺',
        },
        {
          value: '4',
          label: '商品',
        },
      ],

    }
  },
  methods: {
    notGtNum100,
    notLtNum1,
    notLtNum0,

    doSave(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.save))
          params.icon=params.icon.split('?')[0].substring(this.fileBaseUrl.length+1)
          save(params).then(res=>{
            if(res.code===1){
              Message({message:"成功",type:"success",duration:3000})
              this.showSave=false
              this.fetchData()
            }else{
              if(res.data && res.data.illError){
                Message({message:res.data.illError,type:"error",duration:3000})
              }else{
                Message({message:"失败",type:"error",duration:3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    //插入地点
    insertLocation(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const lnglat = this.coord.lnglat.split(',')
          if (lnglat.length!=2) return Message({message:'请正确输入坐标',type:"error",duration:3000})

          this.save.address=this.coord.address
          this.save.lng=lnglat[1]
          this.save.lat=lnglat[0]

          this.showAddCoord = false
          Message({
            message: "成功",
            type: "success",
            duration: 3000
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    onShowMap(){
      this.showAddCoord = true
    },
    getUUID() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";
      var uuid = s.join("");
      return uuid;
    },
    async beforeUpload(){
      await getAliyunOssSign("/common/sign").then(response => {
        //设置相关的参数
        let resultObj = response.data;
        this.uploadData = resultObj;
        this.uploadData.ossaccessKeyId = resultObj.accessid;
        //上传的文件名，使用UUID处理一下
        this.uploadData.key = resultObj.dir + '/' + this.getUUID() + '_${filename}';
      });
      return true
    },
    //文件上传成功回调
    handleSuccess(response, file){
      //上传的完整的文件地址
      var urlPath = this.uploadData.host + '/' + this.uploadData.key.replace("${filename}",file.name) ;
      let filepath = urlPath.substring(this.fileBaseUrl.length+1)
      adminGetFileSignUrl(filepath).then(res=>{
        this.save.icon=res.data
      })
    },
    onShowSave(title,row){
      this.title=title
      this.save={
        isHide:'否',
        icon:undefined,
        width:50,
        height:50,
      }
      if (row){
        this.save=JSON.parse(JSON.stringify(row))
        this.save.icon=this.fileBaseUrl+this.save.icon
      }
      this.showSave=true
    },
    search(){
      this.fetchData()
    },
    reset(){
      this.params = {}
      // this.$refs.cascader.panel.checkedValue = []
      this.fetchData()
    },
    fetchData(){
      list().then(res=>{
        this.records=res.data
      })
    },
  },

  mounted() {
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 60px;

  .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 60px;
    display: block;
  }
}


</style>
